// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PlusCircle: React.FC<{ width?: number; height?: number }> = ({ width = 12, height = 12 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 12 12">
            <path
                fill="currentcolor"
                d="M6 12c3.305 0 6-2.695 6-6S9.305 0 6 0 0 2.695 0 6s2.695 6 6 6Zm-.563-3.938v-1.5h-1.5A.57.57 0 0 1 3.375 6a.57.57 0 0 1 .563-.563h1.5v-1.5A.57.57 0 0 1 6 3.375a.57.57 0 0 1 .563.563v1.5h1.5A.57.57 0 0 1 8.624 6a.57.57 0 0 1-.563.563h-1.5v1.5A.57.57 0 0 1 6 8.624a.57.57 0 0 1-.563-.563Z"
            />
        </svg>
    );
};

export default React.memo(PlusCircle);
